import React from 'react';
// assuming you moved the css we made earlier into this file,
// or you can import it from your main style sheet!
import './style.css';

export const CustomPagination = ({ totalItems, activeIndex, onDotClick }) => {
  return (
    <div className="custom-pagination-container">
      {/* we use array.from to dynamically generate the correct number of dots based on the integer passed */}
      {Array.from({ length: totalItems }).map((_, index) => (
        <div
          key={index}
          className={`custom-dot ${activeIndex === index ? 'active' : ''}`}
          onClick={() => onDotClick(index)}
        />
      ))}
    </div>
  );
};
